import PropTypes from 'prop-types';
import { Box, Chip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import UnassignedField from '@/components/global/fields/UnassignedField.jsx';
import { TextField, FunctionField, useTranslate } from 'react-admin';

const StyledLocationCollectionPointField = styled(Box)(({ theme }) => ({
    '& .pos-field-name': {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        letterSpacing: '-0.14px',
        [theme.breakpoints.up('sm')]: {
            flexWrap: 'nowrap',
        },
        '& .MuiTypography-root.MuiTypography-body2': {
            whiteSpace: 'nowrap',
            [theme.breakpoints.down('md')]: {
                whiteSpace: 'normal',
            },
        },
        '& .pos-field-name-id': {
            whiteSpace: 'nowrap',
            fontWeight: 600,
            '& + .MuiTypography-root.MuiTypography-body2': {
                display: 'inline-block',
                width: 'auto',
                marginRight: '8px',
            },
        },
        '& .pos-field-name-chip': {
            [theme.breakpoints.up('sm')]: {
                marginLeft: '8px',
                flexWrap: 'nowrap',
            },
        },
    },
    '& .pos-field-adress .MuiTypography-root.MuiTypography-caption': {
        fontSize: '11px',
        lineHeight: '16px',
        letterSpacing: '-0.11px',
        maxWidth: '241px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    '& .unassigned-field': {
        marginTop: '20px',
    },
}));

const LocationCollectionPointField = ({ collectionPoint }) => {
    const translate = useTranslate();
    return (
        <Box>
            {collectionPoint ? (
                <StyledLocationCollectionPointField className='location-pos-field'>
                    <Box className='pos-field-name'>
                        <p className='pos-field-name-id'>{collectionPoint.customId},&nbsp;</p>
                        <TextField source='contractor.name' />
                        {collectionPoint.premiumService && (
                            <Chip size='small' label={translate('resources.device.labels.premiumService')} className='pos-field-name-chip chip-small' />
                        )}
                    </Box>
                    <Box className='pos-field-adress'>
                        <FunctionField
                            source='address'
                            render={record => (
                                <Box>
                                    <Typography title={`${record.address}, ${record.postalCode} ${record.city}`} variant='caption'>
                                        {record.address},&nbsp;{record.postalCode}&nbsp;{record.city}
                                    </Typography>
                                </Box>
                            )}
                        />
                    </Box>
                </StyledLocationCollectionPointField>
            ) : (
                <UnassignedField />
            )}
        </Box>
    );
};

const LocationCollectionPointModel = PropTypes.shape({
    id: PropTypes.string.isRequired,
    contractorId: PropTypes.string.isRequired,
    customId: PropTypes.string.isRequired,
    premiumService: PropTypes.bool.isRequired,
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
    address: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    postalCode: PropTypes.string.isRequired,
    province: PropTypes.string,
    country: PropTypes.string.isRequired,
    contactName: PropTypes.string.isRequired,
    contactEmail: PropTypes.string.isRequired,
    contactPhoneNumber: PropTypes.string.isRequired,
    operator: PropTypes.string,
    serviceCompanyId: PropTypes.string.isRequired,
    analytics: PropTypes.shape({
        collectionPointId: PropTypes.string.isRequired,
    }).isRequired,
    devices: PropTypes.arrayOf(
        PropTypes.shape({
            collectionPoint: PropTypes.object.isRequired,
            group: PropTypes.shape({
                id: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
            }).isRequired,
            id: PropTypes.string.isRequired,
            serialNumber: PropTypes.string.isRequired,
            deploymentStatus: PropTypes.string.isRequired,
            state: PropTypes.any,
            binState: PropTypes.any,
        }),
    ).isRequired,
});

LocationCollectionPointField.propTypes = {
    collectionPoint: LocationCollectionPointModel,
};

export default LocationCollectionPointField;
